<template>
  <el-select
    v-model="selectID"
    @change="selectChange"
    :multiple="multiple"
    :disabled="disabled"
    filterable
    placeholder="请选择">
    <el-option
      v-for="item in dataList"
      :key="item.id"
      :label="formatValue(item.kind, 'msgKind')+'-'+item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>

export default {
  data() {
    return {
      selectID: this.typeId,
      dataList: [],
    }
  },
  props: {
    typeId: {
      type: [Number,String,Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
  },
  watch: {
    typeId: function (newVal, oldVal) {
      this.selectID = newVal;
    },
    selectID : function(newVal, oldVal){
      this.$emit("update:typeId", newVal);
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    selectChange(event) {
      console.log(this.dataList)
      let item = this.dataList.find(data=>{
        return data.id === event
      });
      this.$emit('select', event, item);
    },
    getDataList() {
      this.$http({
        url: this.$http.adornUrl('/message/notice-type/select'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.data
        } else {
          console.log(data)
        }
      }).catch((err) => {
        console.log(err);
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/msg-type-select.vue